@import '~style-sheet-helpers/core.less';

.widget-wrapper {
  padding: 8px;
}
